import React from 'react';
import ReactDOM from 'react-dom';

import styled from '@emotion/styled';

import { createReactRenderer } from 'helpers/react-renderer';
import AlertMessageDisplay, {
  AlertMessageDTO,
  AlertType,
} from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';
import { TopbarReactRootSelector } from 'root/apps/components/Topbar/index';

export interface PopOutAlertMessageProps {
  message?: string | React.ReactElement;
  type?: AlertType;
  title?: string;
}

const StyledAlertMessageDisplay = styled(AlertMessageDisplay)`
  position: absolute;
  left: 1.5rem;
  right: 1.5rem;
  top: 1.5rem;
  width: auto;
`;

export const TopbarAlertMessage: React.FC<PopOutAlertMessageProps> = ({ type, message, title }) => {
  if (!message || !type) return null;
  const alertMessage: AlertMessageDTO = {
    message,
    type,
    title,
  };
  const topbarEl = document.querySelector(`${TopbarReactRootSelector} .cr-topbar`);
  if (!topbarEl) return null;
  return ReactDOM.createPortal(<StyledAlertMessageDisplay alertMessage={alertMessage} />, topbarEl);
};

const RenderedComponent = createReactRenderer({
  component: TopbarAlertMessage,
  selector: '[data-react-root="TopbarAlertMessage"]',
});

history.onChangeState(
  // only available on register.php at the moment
  [{ pathname: '/register.php', form_name: undefined, view: undefined }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
